// <핫이슈 박스 컴포넌트>

// 2021.11.01 기획서 기준  광고까지 총 5개 박스

// 2. Box Type2
// https://star.sbs.co.kr/end/index.html?type=theme&id=612f51c09a265574b76f68ae#6167b69757a30b242e437de6
// 스타 테마 포토
// 테마 단위 노출
// 해당 테마의 최신 포토 5개 스와이프로 노출
// 시간은 테마 수정일시 와 포토 업데이트일 중 최신일시> API에서 둘 중 하나 제공
// 마우스 호버 시 좌우 화살표 노출, 이미지 확대X
import React, { useState } from 'react';
import Image from 'next/image';
import ShareBox from './ShareBox';
import Link from 'next/link';
import { toContentDate } from '../../../../../src/common/utils/dateUtil';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';
// 이미지만 배열
export default function Box(props) {
  const [current, setCurrent] = useState(0); // 이미지 및 페이징 부분 위치제어
  const [slideButtonCheck, setSlideButtonCheck] = useState(true);

  const title = props.title; // 타이틀
  const contentDate = props.content_date; // 게시날짜(데이터 케스팅 유무 확인필요)
  const imgUrlList = props.img_url; // 이미지 주소 urlList 맥시멈 갯수 5개 혹시 몰라서 구현시에는 동적으로 구현
  const linkUrl = props.link_url; // 링크 url

  const contentDateCast = contentDate ? toContentDate(contentDate) : '';
  const imgListSize = imgUrlList.length;

  // TODO childmild
  // 이미지 유형 체크
  try {
    const test = imgUrlList[0].substr(0, 4);
    if (test !== 'http') {
      return (
        <>
        </>
      );
    }
  } catch (error) {
    console.error(error);
    return (
      <>
      </>
    );
  }

  function nextEvent() {
    if (imgListSize - 1 === current) {
      setCurrent(0);
    } else {
      setCurrent(current + 1);
    }
  }

  function nextPre() {
    if (current === 0) {
      setCurrent(imgListSize - 1);
    } else {
      setCurrent(current - 1);
    }
  }

  const pagingClick = (item, index) => {
    setCurrent(index);
  };

  function textCode(e){ 
     if( event.keyCode == 13 ){
       
          // var f = document.getElementById('fo');
          // f.elements[e.tabIndex].focus();
     }
}

const moveTouchSlide = (e) => { // 페이징 동작시점에 해당 함수 막기
  // 3. 해당 영역 부분 좌우 구분해서 페이징 처리 하기 좌 페이징  우페이징
  alert(e.changedTouches[0].clientX);
  
};


  return (
    <>
      <div className='hotmodule_box_w_type2'>
        {/* TODO childmild  호버 영역  만들기 */}
        <div className='hmb_photo_slider_w' tabIndex={0}>
          <ul className='hps_list'>

            {/* 해당 영역 루프문  */}
            {imgUrlList.map((item, index) => {
              return (
                //TODO  해당 부분 활성화 로직 해야함 style={{ display: isGnbYn ? '' : 'none' }} style={{ display: current === index ? 'block' : 'none' }}>
                <li key={`type2_img_${index}`} className={`hpsl_inner ${current === index ? 'current' : ''}`} style={{ display: current === index ? 'block' : 'none' }} > 
                  <Link href={getClickLinkParams(linkUrl, 'div=hotissue')} >
                    <a target={"_blank"} rel={"noopener noreferrer"} className='hmb_link'>
                      <div className='hmb_image_w'>
                        {item.endsWith('.gif')
                          ? <img
                            src={item}
                            alt={title}
                          />
                          : <Image
                            className="hmb_image"
                            src={item}
                            alt={title}
                            layout='fill'
                            quality={props.imageQuality || 75}
                          />}
                      </div>
                    </a>
                  </Link>
                </li>
              );
            })}

          </ul>

          <div className='hps_paging_w'>
            <ul className='hps_paging_list'>

              {imgUrlList.map((item, index) => {
                return (
                  <li key={`type2_paging_${index}`} className={`hpl_inner ${current === index ? 'current' : ''}`} >
                    <button type='button' className='hps_paging_btn' onClick={() => pagingClick(item, index)}>
                      <span className='ir'>테마포토 페이징1</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* style={{ opacity:1 }} */}
          <div className='hps_button_w' style={{opacity: slideButtonCheck ? 0 : 1}} onMouseOver={(e) => setSlideButtonCheck(false)} onMouseOut={(e) => setSlideButtonCheck(true)} onKeyUp={(e) => setSlideButtonCheck(false)} onKeyDown={(e) => setSlideButtonCheck(true)}>
            <button type='button' className='hps_btn_prev' onClick={nextPre} >
              <svg xmlns='http://www.w3.org/2000/svg' width='12.414' height='22.828' viewBox='0 0 12.414 22.828'>
                <path data-name='' d='M-11109.5-16189.5l-10,10,10,10' transform='translate(11120.5 16190.914)' fill='none' stroke='#ababab' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
              </svg>
            </button>
            <button type='button' className='hps_btn_next' onClick={nextEvent}>
              <svg xmlns='http://www.w3.org/2000/svg' width='12.414' height='22.828' viewBox='0 0 12.414 22.828'>
                <path data-name='4' d='M-11109.5-16189.5l-10,10,10,10' transform='translate(-11108.086 -16168.086) rotate(180)' fill='none' stroke='#ababab' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
              </svg>
            </button>
          </div>

        </div>

        <Link href={linkUrl}>
          <a className='hmb_link'>
            <div className='hmb_info_w'>

              {contentDate != null && contentDateCast !== null && contentDateCast !== '' && (
                <div className='hmbif_update_time_w'>
                  <span className='icon_update_time'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15.769 16'>
                      <g data-name='Icon feather-clock' transform='translate(0.5 0.5)'>
                        <path d='M17.769,10.5A7.443,7.443,0,0,1,10.385,18,7.443,7.443,0,0,1,3,10.5,7.443,7.443,0,0,1,10.385,3,7.443,7.443,0,0,1,17.769,10.5Z' transform='translate(-3 -3)' />
                        <path d='M18,9v6.231l4.154,2.077' transform='translate(-11.365 -6.769)' />
                      </g>
                    </svg>
                  </span>
                  <span className='text_update_time'>{contentDateCast}</span>
                </div>
              )}

              <strong className='hmbif_title'>{title}</strong>
            </div>
          </a>
        </Link>
        <ShareBox data={props} />
      </div>
    </>
  );
}// Finish default function Box()
